import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Icon, ICONS } from "./Icon";

interface ListRowProps {
  /** Iconify nomi (leading icon). */
  icon?: string;
  title: string;
  subtitle?: string;
  /** Trailing slot. Berilmasa va onClick bo'lsa — chevron. */
  trailing?: ReactNode;
  onClick?: () => void;
  className?: string;
}

/**
 * List row — Figma §5.8. Leading icon orange-tint kvadratda, title 16/600,
 * subtitle 14/500 muted, trailing chevron. Oq karta ichida guruhlanadi.
 */
export function ListRow({ icon, title, subtitle, trailing, onClick, className }: ListRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center gap-3 px-4 py-3.5 text-left transition-colors",
        onClick ? "active:bg-[var(--c-line)]" : "cursor-default",
        className,
      )}
    >
      {icon && (
        <span
          className="grid size-9 shrink-0 place-items-center rounded-xl"
          style={{ background: "var(--c-brand-tint)", color: "var(--primary)" }}
        >
          <Icon name={icon} size={20} />
        </span>
      )}
      <span className="min-w-0 flex-1">
        <span className="block truncate text-base font-semibold" style={{ color: "var(--c-text)" }}>
          {title}
        </span>
        {subtitle && (
          <span className="mt-0.5 block truncate text-sm" style={{ color: "var(--c-text-muted)" }}>
            {subtitle}
          </span>
        )}
      </span>
      {trailing ??
        (onClick && (
          <span style={{ color: "var(--c-text-muted)" }}>
            <Icon name={ICONS.chevronRight} size={18} />
          </span>
        ))}
    </button>
  );
}
